import styled from 'styled-components';
import { cssVars } from '../../../app/styles';
import {
  MONTH_SEPARATION_HEADER_PADDING_HALF,
  MONTH_TITLE_HEIGHT,
  SWIMLANE_LABEL_PADDING_TOP,
  SWIMLANE_LABEL_PANE_WIDTH,
} from '../../constants';

export const MonthTitle = styled.div`
  background: ${cssVars.propertyHistoryColors.monthTitleBg};
  color: ${cssVars.propertyHistoryColors.monthTitleFg};
  padding-left: 32px;
  text-transform: uppercase;
  font-weight: bold;
  height: ${MONTH_TITLE_HEIGHT};
  display: flex;
  align-items: center;
`;
export const MonthSummary = styled.div`
  background: ${cssVars.propertyHistoryColors.monthSummaryBg};
  display: flex;
  gap: ${({ compactLayout }) => (compactLayout ? '10px' : '70px')};

  padding: 2px 25px;
  justify-content: ${({ alignLeft }) =>
    alignLeft ? 'start' : 'space-between'};
  height: 42px;
`;
export const MonthHeader = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 900px;
  padding: 0 ${MONTH_SEPARATION_HEADER_PADDING_HALF} 0;
  border-bottom: ${SWIMLANE_LABEL_PADDING_TOP} solid
    ${cssVars.propertyHistoryColors.swimlaneLabelPaneBg} !important;
  ${({ suppressLeftBorder }) => (!suppressLeftBorder ? '' : 'padding-left: 0')};
  ${({ suppressRightBorder }) =>
    !suppressRightBorder ? '' : 'padding-right: 0'};
`;
export const MonthContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0px;

  &:nth-child(1) {
    padding-left: ${SWIMLANE_LABEL_PANE_WIDTH};
  }
`;
